type Resource = {
  id: string
  type: string
  attributes?: Record<string, any>
  relationships?: Record<string, { data?: { id: string; type: string } | null }>
}

const findIncluded = (included: Resource[], type: string, id?: string) =>
  id ? included.find(item => item.type === type && item.id === id) : undefined

// Ward / room / bed for an encounter, from the bed-stay graph included by GET encounters/:id.
// Uses the open stay, or the most recent one once the patient has been discharged.
export const getEncounterLocation = (included?: Resource[]) => {
  if (!included?.length) return undefined

  const stays = included
    .filter(item => item.type === 'encounter_bed_stay')
    .sort((a, b) => String(b.attributes?.started_at).localeCompare(String(a.attributes?.started_at)))
  const stay = stays.find(item => !item.attributes?.ended_at) || stays[0]

  const bed = findIncluded(included, 'bed', stay?.relationships?.bed?.data?.id)
  const room = findIncluded(included, 'room', bed?.relationships?.room?.data?.id)
  const unit = findIncluded(included, 'unit', room?.relationships?.unit?.data?.id)

  const parts = [
    unit?.attributes?.name,
    room?.attributes?.room_number && `Room ${room.attributes.room_number}`,
    bed?.attributes?.ref && `Bed ${bed.attributes.ref}`
  ].filter(Boolean)

  return parts.length ? parts.join(' · ') : undefined
}
